var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar elm-desktop"},[_c('CarInfo'),(_vm.desktopResume)?_c('UpdatedResume',{attrs:{"screen":"desktop","dealer":_vm.dealer,"services":_vm.services,"mobility":_vm.mobility,"wash":_vm.wash,"schedule":_vm.schedule}}):_vm._e(),(_vm.servicesScreen)?_c('ServicesTotal',{attrs:{"screen":"desktop"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }